<template>
  <o-modal :active="isComponentModalActive" :canCancel="false" class="modal-md">
    <div class="modal-card">
      <o-loading :active="isLoading" :can-cancel="false"></o-loading>
      <header class="modal-card-head">
        <h3 class="modal-card-title">Replace Location</h3>
        <span class="has-text-black  is-left">Some orders may be using the selected locations.
          Please select a new location for these orders.</span>
      </header>
      <section class="modal-card-body">
        <data-table :apiMode="true" :tableOpts="getOpts" :loadData="loadData" :isCheckable="true" @checkbox-toggled="toggleLocation" :checkableHeader="false" :singleSelection="true" :key="refreshModalTable">

        </data-table>
      </section>
      <footer class="modal-card-foot is-justify-content-flex-end">
        <div class="">
          <button class="button is-cancel is-outlined has-text-black-bis" @click="cancel()">Cancel</button>
          <button class="button has-background-black-bis has-text-white" :disabled="$_.isEmpty(fallbackLocationlist)"
            @click="fallbackLocation">Select
          </button>
        </div>
      </footer>
    </div>
  </o-modal>
</template>

<script>
import {
  computed,
  defineComponent,
  getCurrentInstance,
  onMounted,
  ref,
  toRefs,
  reactive,
} from 'vue';
import { useToast } from 'vue-toastification';
import { useStore } from 'vuex';
import DataTable from "@/components/table-fields/DataTable.vue";
import CompanyLocationsCols from '@/components/table-cols/companyLocationsCols';
import Locations from '@/models/Locations';
import { remove } from 'lodash';

export default defineComponent({
  name: 'DeleteLocation',
  props: {
    isComponentModalActive: {
      type: Boolean,
      default: false,
    },
    locType: {
      type: String,
      default: '',
    },
    locationsList: {
      type: Object,
      default: () => ({}),
    },
    selectedLocs: {
      type: Array,
      default: () => [],
    },
  },
  components: { DataTable },
  setup(props, { emit }) {
    const store = useStore();
    const toast = useToast();
    const data = reactive({
      tableName: 'deleteLocations',
      fields: [],
      selected: {},
      isLoading: false,
      fallbackLocationlist: '',
      allLocations: [],
      tableOpts: CompanyLocationsCols,
    });
    const getOpts = computed(() => {
      data.tableOpts.fields.pop();
      return data.tableOpts;
    });

    const loadData = async () => {
      props.selectedLocs.forEach((loc) => {
        remove(props.locationsList.data, (location) => location._id === loc._id);
      });
      return props.locationsList;
    }

    const fallbackLocation = async () => {
      emit('deleteCompanyLoc', data.fallbackLocationlist);
    };

    const toggleLocation = (location) => {
      data.fallbackLocationlist = location[0]._id;
    };

    const cancel = () => {
      emit('close-modal');
    };

    return {
      ...toRefs(data),
      loadData,
      toggleLocation,
      fallbackLocation,
      cancel,
      getOpts,
    };
  },
});
</script>
<style lang="scss" scoped>
::v-deep(.o-table__td-checkbox ~ .o-table__td--sticky, .o-table__th-checkbox ~ .o-table__th--sticky) {
  left: unset !important;
 }
 ::v-deep(.o-table thead tr:nth-child(2)) {
  display: none;
 }
 ::v-deep(.modal-card-body .mf-table .o-table__wrapper .o-table thead tr th) {
  background-color: #e6e6e6 !important;
 }
 ::v-deep(.o-table thead tr th:nth-child(2)) {
  left: unset !important;
 }
 ::v-deep(.modal-card-body .mf-table .o-table__wrapper .o-table__th::after) {
  top: 18px;
  width: 1px !important;
 }
</style>
